import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

export const InboundNotifyPanel = ({ s, setS }) => (
    <div className="rounded-lg border border-border bg-background p-4 space-y-4" data-testid="inbound-notify-panel">
        <div className="flex items-start justify-between gap-4">
            <div>
                <div className="text-sm font-medium">Enable inbound reply notifications</div>
                <p className="text-xs text-muted-foreground mt-0.5">
                    Sends one notification text to your cell for each new client text reply
                    (name if matched, sender number, reply text). Notification only, so nothing
                    is forwarded to clients. Uses the voicemail Twilio messaging route above.
                </p>
            </div>
            <Switch
                checked={!!s.inbound_notify_enabled}
                onCheckedChange={(v) => setS({ ...s, inbound_notify_enabled: v })}
                data-testid="inbound-notify-enabled-toggle"
            />
        </div>
        <div className="max-w-sm">
            <Label>Notification phone number (E.164)</Label>
            <Input
                value={s.inbound_notify_phone_e164 || ""}
                onChange={e => setS({ ...s, inbound_notify_phone_e164: e.target.value })}
                placeholder="+15551234567"
                data-testid="inbound-notify-phone-input"
            />
            <p className="text-[11px] text-muted-foreground mt-1">
                Texts from this number are saved as internal staff messages and never trigger a notification.
            </p>
        </div>
    </div>
);
